import { FIELDS, PICKUP_TYPE_DOCTOR, PICKUP_TYPE_HOME } from '../constants';

export const initialFormState = {
  [FIELDS.FACILITY_ID]: null,
  [FIELDS.RESIDENT_IDS]: [],
  [FIELDS.HAS_EXISTING_APPOINTMENT]: true,
  [FIELDS.PICKUP_TIME]: null,
  [FIELDS.RETURN_TRIP_PICKUP_TIME]: null,
  [FIELDS.APPOINTMENT_DATE_TIME]: null,
  [FIELDS.SEEN_BY_DATE]: null,
  [FIELDS.CREATE_RETURN_TRIP]: true,
  [FIELDS.AIDE_REQUIRED]: null,
  [FIELDS.UNIT_AIDE_REQUIRED]: null,
  [FIELDS.CNA_REQUIRED]: null,
  [FIELDS.PCS_FORM]: false,
  [FIELDS.DETAIL_O2]: false,
  [FIELDS.DETAIL_SNACK]: false,
  [FIELDS.DETAIL_LUNCH]: false,
  [FIELDS.DETAIL_XRAYS]: false,
  [FIELDS.DETAIL_RESIDENT_DOCUMENTS]: false,
  [FIELDS.DETAIL_CUSHION]: false,
  [FIELDS.DETAIL_HOYER_LIFT_PAD]: false,
  [FIELDS.DETAIL_WHEELCHAIR]: false,
  [FIELDS.TRANSPORT_TYPE_ID]: null,
  [FIELDS.TRANSPORT_TYPE_NAME]: null,
  [FIELDS.PICKUP_LOCATION_TYPE]: PICKUP_TYPE_HOME,
  [FIELDS.PICKUP_DOCTOR_ID]: null,
  [FIELDS.DROPOFF_LOCATION_TYPE]: PICKUP_TYPE_DOCTOR,
  [FIELDS.DROPOFF_DOCTOR_ID]: null,
  [FIELDS.IS_OUTSOURCED]: null,
  [FIELDS.OUTSOURCE_COMPANY_ID]: null,
  [FIELDS.VEHICLE_ID]: null,
  [FIELDS.ASSIGNED_DRIVER_ID]: null,
  [FIELDS.APPOINTMENT_DESC]: '',
  [FIELDS.IS_RECURRING]: false,
  [FIELDS.RECURRENCE_TYPE]: null,
  [FIELDS.RECURRENCE_FREQUENCY]: null,
  [FIELDS.RECURRENCE_WEEK_OF_MONTH]: null,
  [FIELDS.RECURRENCE_END_DATE]: null,
  [FIELDS.RECURRENCE_DAYS_OF_WEEK]: null,
  [FIELDS.RECURRENCE_DAY_OF_MONTH]: null,
  [FIELDS.OCCURRENCE_DATE]: null,
  [FIELDS.PARENT_APPOINTMENT_DATE]: null,
  [FIELDS.DATE_ADDED]: null,
  [FIELDS.ADDED_BY]: null,
  [FIELDS.REQUEST_STATUS_ID]: null,
};

export const formReducer = (state, action) => {
  switch (action.type) {
    case 'setFacilityId':
      return { ...state, [FIELDS.FACILITY_ID]: action.payload ?? null, [FIELDS.RESIDENT_IDS]: [] };
    case 'setFields': {
      if (action.fields && typeof action.fields === 'object') {
        return { ...state, ...action.fields };
      }
      return state;
    }
    case 'reset':
      return initialFormState;
    default:
      return state;
  }
};
